// eslint-disable-next-line no-restricted-imports
import { AuthContext, useAuthProvider } from './auth0';

export const Auth0Provider = ({ children }: { children: any }) => {
  const auth = useAuthProvider();
  return (
    <AuthContext.Provider value={auth as any}>{children}</AuthContext.Provider>
  );
};
